import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  "data-testid": "push-prompt-modal-title",
  class: "d-flex align-items-center ml-3"
}
const _hoisted_2 = {
  "data-testid": "push-prompt-modal-title-bell",
  class: "mr-2"
}
const _hoisted_3 = {
  "data-testid": "push-prompt-modal-title-text",
  class: "font-weight-bold font-size-xl"
}
const _hoisted_4 = {
  "data-testid": "push-prompt-modal-description",
  class: "w-100 text-center mt-2 mb-2"
}
const _hoisted_5 = {
  "data-testid": "push-prompt-modal-description-one",
  class: "pb-2"
}
const _hoisted_6 = {
  "data-testid": "push-prompt-modal-description-two",
  class: "pb-2"
}
const _hoisted_7 = { class: "flex-grow-1 d-flex" }


import WCModal from '@/modules/modals/components/WCModal/WCModal.vue';
import WCModalHeader from '@/modules/modals/components/WCModalHeader/WCModalHeader.vue';
import WCModalBody from '@/modules/modals/components/WCModalBody/WCModalBody.vue';
import WCModalFooter from '@/modules/modals/components/WCModalFooter/WCModalFooter.vue';
import { MODAL_EVENTS } from '@/constants/EventConstants';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useI18n } from 'vue-i18n';
// eslint-disable-next-line import/no-cycle
import usePushNotifications from '@/composables/usePushNotifications';

interface Props {
  dismiss: Function;
  close: Function;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WCPushPromptModal',
  props: {
    dismiss: { type: Function },
    close: { type: Function }
  },
  setup(__props: any) {

const props = __props;
const { t } = useI18n();
const { optInToNotifications, optOutOfNotifications } = usePushNotifications();

const handleOptOut = () => {
  optOutOfNotifications()?.catch(error => {
    console.error('Error opting out of notifications:', error);
  });
  props.close(MODAL_EVENTS.CANCEL);
};

const handleOptIn = () => {
  optInToNotifications()?.catch(error => {
    console.error('Error opting in to notifications:', error);
  });
  props.close(MODAL_EVENTS.CANCEL);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(WCModal, {
    position: "center",
    onDismiss: _cache[0] || (_cache[0] = ($event: any) => (props.dismiss(_unref(MODAL_EVENTS).DISMISS))),
    "data-testid": "push-prompt-modal"
  }, {
    default: _withCtx(() => [
      _createVNode(WCModalHeader, { class: "d-flex justify-content-between align-items-center" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", _hoisted_2, [
              _createVNode(_unref(FontAwesomeIcon), {
                class: "text-primary mr-2",
                icon: "bell",
                size: "2x"
              })
            ]),
            _cache[1] || (_cache[1] = _createTextVNode()),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('turnOnNotifications')), 1)
          ])
        ]),
        _: 1
      }),
      _cache[4] || (_cache[4] = _createTextVNode()),
      _createVNode(WCModalBody, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('getUpdatesAboutOrder')), 1),
            _cache[2] || (_cache[2] = _createTextVNode()),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('youCanChangeThisInYourAccount')), 1)
          ])
        ]),
        _: 1
      }),
      _cache[5] || (_cache[5] = _createTextVNode()),
      _createVNode(WCModalFooter, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              "data-testid": "push-prompt-modal-no-button",
              class: "btn btn-outline-primary flex-grow-1 mr-4",
              onClick: handleOptOut
            }, _toDisplayString(_unref(t)('noThanks')), 1),
            _cache[3] || (_cache[3] = _createTextVNode()),
            _createElementVNode("button", {
              "data-testid": "push-prompt-modal-yes-button",
              class: "btn btn-primary flex-grow-1",
              onClick: handleOptIn
            }, _toDisplayString(_unref(t)('turnOn')), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})